/**
 * 客户端配置选项接口
 * @interface ClientConfigOptions
 */
export interface ClientConfigOptions {
   /** 应用ID，用于API身份验证 */
   applicationId: string;
   /** 业务ID，用于区分不同业务场景 */
   businessId: string;
   /** API基础URL地址 */
   baseUrl: string;
   /** 私钥 */
   privateKeys: string;

   /** 请求超时时间（毫秒），默认为10000 */
   timeout?: number;
   /** 自定义请求头 */
   headers?: Record<string, string>;
}

/**
 * 客户端配置类
 * 管理API客户端的配置信息，包括应用凭证、请求设置等
 * @class ClientConfig
 */
export class ClientConfig {
   /** 应用ID，用于API身份验证 */
   readonly applicationId: string;
   /** 业务ID，用于区分不同业务场景 */
   readonly businessId: string;
   /** API基础URL地址 */
   readonly baseUrl: string;
   /** 私钥 */
   readonly privateKeys: string;
   /** 请求超时时间（毫秒） */
   readonly timeout?: number;
   /** 自定义请求头 */
   readonly headers?: Record<string, string>;
   
   /**
    * 创建客户端配置实例
    * @param {ClientConfigOptions} options - 客户端配置选项
    */
   constructor(options: ClientConfigOptions) {
      this.applicationId = options.applicationId;
      this.businessId = options.businessId;
      this.baseUrl = options.baseUrl;
      this.privateKeys = options.privateKeys;
      this.timeout = options.timeout;
      this.headers = options.headers;
   }
   
   /**
    * 获取完整的配置对象
    * @returns {ClientConfigOptions} 配置对象
    */
   getConfig(): ClientConfigOptions {
      return {
         applicationId: this.applicationId,
         businessId: this.businessId,
         privateKeys: this.privateKeys,
         baseUrl: this.baseUrl,
         timeout: this.timeout,
         headers: this.headers
      };
   }
}